import React from 'react';

const ServiceSelector = ({ selectedService, onServiceChange }) => {
  const services = [
    {
      id: 'ride',
      label: 'Ride',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
          <path d="M5 17H3a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v5" />
          <circle cx="16" cy="17" r="2" />
          <circle cx="7" cy="17" r="2" />
          <path d="M14 17H9" />
        </svg>
      ),
      description: 'Get a ride anywhere'
    },
    {
      id: 'delivery',
      label: 'Delivery',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      ),
      description: 'Send packages fast'
    }
  ];

  return (
    <div className="flex bg-[#0a1628]/10 rounded-2xl p-1.5 gap-1">
      {services?.map((service) => (
        <button
          key={service?.id}
          onClick={() => onServiceChange(service?.id)}
          className={`flex-1 flex items-center justify-center gap-2.5 py-3 px-4 rounded-xl font-semibold text-sm transition-all duration-300 ${
            selectedService === service?.id
              ? 'bg-[#0a1628] text-[#ffd700] shadow-lg scale-[1.02]'
              : 'text-[#0a1628]/60 hover:text-[#0a1628] hover:bg-white/50'
          }`}
        >
          <span className={selectedService === service?.id ? 'text-[#ffd700]' : 'text-[#0a1628]/50'}>
            {service?.icon}
          </span>
          <span>{service?.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ServiceSelector;
